import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/CreateAccountLink/CreateAccountLink";
export * from "./types/CreateAccountTeamLink/CreateAccountTeamLink";
export * from "./types/CreateAccountTeamUserLink/CreateAccountTeamUserLink";
export * from "./types/CreateAccountUserLink/CreateAccountUserLink";
export * from "./types/DeleteAccountLink/DeleteAccountLink";
export * from "./types/DeleteLink/DeleteLink";
export * from "./types/GetLink/GetLink";
export * from "./types/GetTarget/GetTarget";
export * from "./types/GetTeamLink/GetTeamLink";
export * from "./types/GetUserLink/GetUserLink";
export * from "./types/ListLinks/ListLinks";
export * from "./types/ListTeamLinks/ListTeamLinks";
export * from "./types/ListUserLinks/ListUserLinks";
export * from "./types/LockAccountUserLink/LockAccountUserLink";
const endpoints = {
    global: "https://link.fromsmash.co",
};
config.setHosts("link", endpoints, false);
export class Link extends Client {
    constructor(params = {}) {
        super({ service: "link", ...params, type: "global", userAgent: "@smash-sdk/link@1.0.0-alpha.2" });
        this.errors = errors;
    }
    createAccountLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        user: params["user"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createAccountTeamLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/team/:teamId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        user: params["user"],
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountTeamLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createAccountTeamUserLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/team/:teamId/user/:userId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountTeamUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createAccountUserLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account/:accountId/user/:userId/link",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        domain: params["domain"],
                        customUrl: params["customUrl"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteAccountLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/account/:accountId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteAccountLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTarget(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/target/:targetId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        targetId: params["targetId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTargetError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/link/:linkId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listLinks() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamLinks(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserLinks(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/links",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserLinksError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    lockAccountUserLink(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/account/:accountId/user/:userId/link/:linkId/lock",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        accountId: params["accountId"],
                        userId: params["userId"],
                        linkId: params["linkId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        target: params["target"],
                        region: params["region"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.LockAccountUserLinkError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Link.errors = errors;
